
import './App.css';
import MemoTest from './components/Cards/memo_test';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


const App = ()=>{
 
  return (
   <>
   <MemoTest/>
    </>
  );
}

export default App;





